import React from "react";

// MUI
import { Box, Tabs, Stack } from "@mui/material";

// Styles
import { styles } from "./styles";

const MNTabs = ({ value, onChange, tabName, children, ...rest }) => {
  return (
    <Stack sx={styles.root}>
      <Box sx={styles.tabsRow}>
        <Tabs
          value={value}
          onChange={onChange}
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          sx={styles.MNTabsStyle}
          aria-label={tabName}
          textColor="inherit"
          {...rest}
        >
          {children}
        </Tabs>
        <Box sx={styles.line} />
      </Box>
    </Stack>
  );
};

export default MNTabs;
